var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view-tasklists" },
    [
      _c("user-menu"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrapper page_to_up" },
        [
          _vm.masterAdmin === true && !_vm.$store.state.switch_admin_username
            ? _c("masteradmin-sidebar-menu")
            : _vm._e(),
          _vm._v(" "),
          _vm.admin === true || _vm.$store.state.switch_admin_username
            ? _c("admin-sidebar-menu")
            : _vm._e(),
          _vm._v(" "),
          _vm.csr == true ? _c("CSRSidebarMenu") : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "content-wrapper" },
            [
              _c("div", { staticClass: "container-wrapper center" }, [
                _c("div", [
                  _c("div", { staticClass: "form_row" }, [
                    _c("div", { staticClass: "form_col_1" }, [
                      _c("h3", { staticClass: "d-inline heading" }, [
                        _vm._v(_vm._s(_vm.pageHeading))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form_col_2" }, [
                      _c(
                        "div",
                        {
                          staticClass: "float-right scroll_box cursor-pointer"
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "scroll_up_down",
                              on: {
                                click: function($event) {
                                  return _vm.scrollToElement("down")
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-angle-down angle_font"
                              })
                            ]
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "heading-seperator" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "float-left col-md-10 col-12 override-padding",
                      staticStyle: { "font-size": "16px" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "text-align-center",
                          staticStyle: { "padding-top": "7px" }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.sub_tasklist_obj.tasklist.name) +
                              "\n                "
                          ),
                          _c("i", {
                            staticClass: "cursor-pointer fa fa-pencil-square-o",
                            staticStyle: { "font-size": "15px !important" },
                            attrs: { "aria-hidden": "true" },
                            on: {
                              click: function($event) {
                                return _vm.editTaskListModalAction()
                              }
                            }
                          })
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "float-right col-md-2 col-12 override-padding",
                      staticStyle: { "padding-top": "5px" }
                    },
                    [
                      _vm.addSubtaskShow === false
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-red btn-md input-height-15 float-right text-align-right",
                              on: {
                                click: function($event) {
                                  _vm.addSubtaskShow = true
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-plus spacer-icon",
                                attrs: { "aria-hidden": "true" }
                              }),
                              _vm._v("Sub Task")
                            ]
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticStyle: { clear: "both" } }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "heading-seperator",
                    staticStyle: { "margin-top": "5px" }
                  })
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "margin-bottom-5",
                  staticStyle: { clear: "both" }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "margin-bottom-5" }, [
                  _vm._v("Sub-task Lists:")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 override-padding" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "task-list-summary float-left col-10 override-padding",
                      staticStyle: { "padding-top": "1px" }
                    },
                    [
                      _c("span", [_vm._v("Tasks List Summary:")]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "padding-left": "25px" } }, [
                        _vm._v(_vm._s(_vm.subtaskCount) + " Sections")
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "padding-left": "25px" } }, [
                        _vm._v(_vm._s(_vm.headingsCount) + " Sub Sections")
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "padding-left": "25px" } }, [
                        _vm._v(_vm._s(_vm.tasksCount) + " Tasks")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  this.sub_tasklist_obj.sub_tasklists_lists.length > 0
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "submit float-right col-2 override-padding",
                          on: { click: _vm.onSubmit }
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "col-12 btn btn-red btn-md col-12 input-height-15",
                              attrs: { type: "submit" }
                            },
                            [_vm._v("Save List")]
                          )
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "margin-bottom-10",
                  staticStyle: { clear: "both" }
                }),
                _vm._v(" "),
                _vm.addSubtaskShow === true
                  ? _c(
                      "div",
                      { staticClass: "subtaskadd col-12 override-padding" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-lg-10 col-sm-9 col-12 float-left override-padding",
                            staticStyle: { "padding-right": "5px" }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.sub_tasklists,
                                  expression: "sub_tasklists"
                                }
                              ],
                              ref: "sub_tasklists",
                              staticClass: "col-12 input-height-25",
                              attrs: {
                                type: "text",
                                name: "sub_tasklists",
                                id: "sub_tasklists",
                                placeholder: "Enter Sub-Tasklist Title",
                                maxlength: "255"
                              },
                              domProps: { value: _vm.sub_tasklists },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.sub_tasklists = $event.target.value
                                }
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-lg-2 col-sm-3 col-12 float-right override-padding text-align-right"
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-red save-button-width btn-md input-height-15",
                                on: { click: _vm.addSubtasksAction }
                              },
                              [_c("b", [_vm._v("Save")])]
                            ),
                            _vm._v(" "),
                            _c("i", {
                              staticClass: "cursor-pointer fa fa-times",
                              staticStyle: { "padding-left": "10px" },
                              attrs: { "aria-hidden": "true" },
                              on: {
                                click: function($event) {
                                  return _vm.closeAddSubtaskInput()
                                }
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticStyle: { clear: "both" } })
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "subtask_list" }, [
                  _c(
                    "ul",
                    {
                      directives: [
                        {
                          name: "sortable",
                          rawName: "v-sortable",
                          value: {
                            onEnd: _vm.reorderSubtask,
                            handle: ".handle1"
                          },
                          expression:
                            "{onEnd: reorderSubtask, handle: '.handle1'}"
                        }
                      ],
                      staticClass:
                        "counter_subtask-list list-group col-lg-12 override-padding margin-bottom-10"
                    },
                    _vm._l(_vm.sub_tasklist_obj.sub_tasklists_lists, function(
                      sub_tasklist,
                      subTaskIndex
                    ) {
                      return _c(
                        "li",
                        {
                          key: sub_tasklist.sortid,
                          staticClass: "list-group-item input-height-25"
                        },
                        [
                          _c("div", { staticClass: "subtask_item" }, [
                            _c(
                              "div",
                              {
                                staticClass: " float-left",
                                staticStyle: { width: "54.66%" }
                              },
                              [
                                sub_tasklist.edit
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "float-left col-12 override-padding"
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: sub_tasklist.name,
                                              expression: "sub_tasklist.name"
                                            }
                                          ],
                                          staticClass:
                                            "col-lg-10 input-height-20",
                                          attrs: { maxlength: "255" },
                                          domProps: {
                                            value: sub_tasklist.name
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                sub_tasklist,
                                                "name",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-red btn-md input-height-15",
                                            on: {
                                              click: function($event) {
                                                return _vm.updateSubtasksAction(
                                                  sub_tasklist
                                                )
                                              }
                                            }
                                          },
                                          [_c("b", [_vm._v("Save")])]
                                        )
                                      ]
                                    )
                                  : _c(
                                      "div",
                                      {
                                        staticClass:
                                          "handle1 float-left override-padding col-12 custom-checkbox",
                                        staticStyle: { "padding-top": "2px" }
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa fa-arrows padding-right-5",
                                          attrs: { "aria-hidden": "true" }
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass:
                                            "counter_subtask-list__counter"
                                        }),
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(sub_tasklist.name) +
                                            " "
                                        ),
                                        _c("i", {
                                          staticClass:
                                            "cursor-pointer fa fa-pencil-square-o",
                                          attrs: { "aria-hidden": "true" },
                                          on: {
                                            click: function($event) {
                                              sub_tasklist.edit = true
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: sub_tasklist.enableAddRep,
                                              expression:
                                                "sub_tasklist.enableAddRep"
                                            }
                                          ],
                                          staticClass: "custom-control-input",
                                          attrs: {
                                            name: "subtask_add_rep_enabled",
                                            id: sub_tasklist.sortid,
                                            type: "checkbox",
                                            disabled: sub_tasklist.disabled
                                          },
                                          domProps: {
                                            value: sub_tasklist.id,
                                            checked: Array.isArray(
                                              sub_tasklist.enableAddRep
                                            )
                                              ? _vm._i(
                                                  sub_tasklist.enableAddRep,
                                                  sub_tasklist.id
                                                ) > -1
                                              : sub_tasklist.enableAddRep
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.changeSubtasksAddRep(
                                                subTaskIndex,
                                                $event
                                              )
                                            },
                                            change: function($event) {
                                              var $$a =
                                                  sub_tasklist.enableAddRep,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = sub_tasklist.id,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      sub_tasklist,
                                                      "enableAddRep",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      sub_tasklist,
                                                      "enableAddRep",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  sub_tasklist,
                                                  "enableAddRep",
                                                  $$c
                                                )
                                              }
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("label", {
                                          staticClass: "custom-control-label",
                                          staticStyle: {
                                            "margin-top": "2px",
                                            "margin-left": "30px"
                                          },
                                          attrs: { for: sub_tasklist.sortid }
                                        }),
                                        _vm._v(" "),
                                        _c("label", [
                                          _vm._v(
                                            "\n                          Add Rep at Section Level\n                      "
                                          )
                                        ])
                                      ]
                                    )
                              ]
                            ),
                            _vm._v(" "),
                            sub_tasklist.tasks.length > 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "float-left font-15  text-center override-padding",
                                    staticStyle: { width: "10.67%" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  Rep Goal\n                "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            sub_tasklist.tasks.length > 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "float-left font-15 text-center override-padding",
                                    staticStyle: { width: "14.33%" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  Rep Competency\n                "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  " float-right override-padding text-align-right",
                                staticStyle: { width: "19.33%" }
                              },
                              [
                                sub_tasklist.tasks_count > 0
                                  ? _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "#007BFF",
                                          "padding-right": "1px",
                                          "font-size": "15px"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "(Tasks: " +
                                            _vm._s(sub_tasklist.tasks_count) +
                                            ")"
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                sub_tasklist.addHeadingButtonShow === true
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-red save-button-width btn-md input-height-15",
                                        on: {
                                          click: function($event) {
                                            return _vm.HeadingClick(
                                              sub_tasklist
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-plus",
                                          attrs: { "aria-hidden": "true" }
                                        }),
                                        _vm._v(" Header")
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                sub_tasklist.addTaskButtonShow === true
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-red save-button-width btn-md input-height-15",
                                        on: {
                                          click: function($event) {
                                            return _vm.TaskClick(
                                              sub_tasklist,
                                              subTaskIndex
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-plus",
                                          attrs: { "aria-hidden": "true" }
                                        }),
                                        _vm._v(" Task")
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.sub_tasklist_obj.tasklist.status == "DRAFT"
                                  ? _c("i", {
                                      staticClass: "cursor-pointer fa fa-times",
                                      staticStyle: { "padding-left": "10px" },
                                      attrs: { "aria-hidden": "true" },
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteSubTaskConfirm(
                                            subTaskIndex
                                          )
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticStyle: { clear: "both" } })
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "heading_container",
                              class:
                                sub_tasklist.headings.length > 0
                                  ? "margin-bottom-5"
                                  : ""
                            },
                            [
                              sub_tasklist.addHeadingShow === true
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "headingadd col-12 override-padding"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-lg-10 col-sm-9 col-12 float-left override-padding",
                                          staticStyle: {
                                            "padding-right": "5px"
                                          }
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  sub_tasklist.headingTitle,
                                                expression:
                                                  "sub_tasklist.headingTitle"
                                              }
                                            ],
                                            staticClass:
                                              "col-lg-12 input-height-25",
                                            attrs: {
                                              type: "text",
                                              placeholder: "Enter Header",
                                              maxlength: "255"
                                            },
                                            domProps: {
                                              value: sub_tasklist.headingTitle
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  sub_tasklist,
                                                  "headingTitle",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-lg-2 col-sm-3 col-12 float-right override-padding text-align-right"
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-red save-button-width btn-md input-height-15",
                                              on: {
                                                click: function($event) {
                                                  return _vm.addHeadingsAction(
                                                    sub_tasklist,
                                                    subTaskIndex
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-plus",
                                                attrs: { "aria-hidden": "true" }
                                              }),
                                              _vm._v(" Save")
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("i", {
                                            staticClass:
                                              "cursor-pointer fa fa-times",
                                            staticStyle: {
                                              "padding-left": "10px"
                                            },
                                            attrs: { "aria-hidden": "true" },
                                            on: {
                                              click: function($event) {
                                                return _vm.closeAddHeadingInput(
                                                  subTaskIndex
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticStyle: { clear: "both" }
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              sub_tasklist.tasks.length === 0
                                ? _c("div", { staticClass: "heading_list" }, [
                                    _c(
                                      "ul",
                                      {
                                        directives: [
                                          {
                                            name: "sortable",
                                            rawName: "v-sortable",
                                            value: {
                                              onEnd: _vm.reorderSubtaskHeading,
                                              handle: ".handle2",
                                              group: {
                                                name: "subtask-" + subTaskIndex,
                                                put: _vm.createHeaderGroupArray()
                                              }
                                            },
                                            expression:
                                              "{onEnd: reorderSubtaskHeading, handle: '.handle2', group: { name: 'subtask-' + subTaskIndex, put: createHeaderGroupArray() } }"
                                          }
                                        ],
                                        staticClass:
                                          "counter_heading-list list-group col-lg-12 override-padding",
                                        attrs: { "data-id": subTaskIndex }
                                      },
                                      _vm._l(sub_tasklist.headings, function(
                                        heading,
                                        headingIndex
                                      ) {
                                        return _c(
                                          "li",
                                          {
                                            key: heading.sortid,
                                            staticClass:
                                              "list-group-item input-height-25"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "heading_item" },
                                              [
                                                heading.edit
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "float-left  override-padding",
                                                        staticStyle: {
                                                          width: "53.66%"
                                                        }
                                                      },
                                                      [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                heading.name,
                                                              expression:
                                                                "heading.name"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "col-lg-8 col-sm-8 col-8 input-height-25",
                                                          attrs: {
                                                            maxlength: "255"
                                                          },
                                                          domProps: {
                                                            value: heading.name
                                                          },
                                                          on: {
                                                            input: function(
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.$set(
                                                                heading,
                                                                "name",
                                                                $event.target
                                                                  .value
                                                              )
                                                            }
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn btn-red btn-md input-height-15",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.updateHeadingsAction(
                                                                  heading
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("b", [
                                                              _vm._v("Save")
                                                            ])
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "handle2 float-left  override-padding custom-checkbox",
                                                        staticStyle: {
                                                          width: "53.66%",
                                                          "padding-top": "2px"
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-arrows padding-right-5",
                                                          attrs: {
                                                            "aria-hidden":
                                                              "true"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("span", {
                                                          staticClass:
                                                            "counter_heading-list__counter"
                                                        }),
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(
                                                              heading.name
                                                            ) +
                                                            " "
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "cursor-pointer fa fa-pencil-square-o",
                                                          attrs: {
                                                            "aria-hidden":
                                                              "true"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              heading.edit = true
                                                            }
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                heading.enableAddRep,
                                                              expression:
                                                                "heading.enableAddRep"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "custom-control-input",
                                                          attrs: {
                                                            name:
                                                              "heading_add_rep_enabled",
                                                            id: heading.sortid,
                                                            type: "checkbox",
                                                            disabled:
                                                              heading.disabled
                                                          },
                                                          domProps: {
                                                            value: heading.id,
                                                            checked: Array.isArray(
                                                              heading.enableAddRep
                                                            )
                                                              ? _vm._i(
                                                                  heading.enableAddRep,
                                                                  heading.id
                                                                ) > -1
                                                              : heading.enableAddRep
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.changeHeadingsAddRep(
                                                                subTaskIndex,
                                                                headingIndex,
                                                                $event
                                                              )
                                                            },
                                                            change: function(
                                                              $event
                                                            ) {
                                                              var $$a =
                                                                  heading.enableAddRep,
                                                                $$el =
                                                                  $event.target,
                                                                $$c = $$el.checked
                                                                  ? true
                                                                  : false
                                                              if (
                                                                Array.isArray(
                                                                  $$a
                                                                )
                                                              ) {
                                                                var $$v =
                                                                    heading.id,
                                                                  $$i = _vm._i(
                                                                    $$a,
                                                                    $$v
                                                                  )
                                                                if (
                                                                  $$el.checked
                                                                ) {
                                                                  $$i < 0 &&
                                                                    _vm.$set(
                                                                      heading,
                                                                      "enableAddRep",
                                                                      $$a.concat(
                                                                        [$$v]
                                                                      )
                                                                    )
                                                                } else {
                                                                  $$i > -1 &&
                                                                    _vm.$set(
                                                                      heading,
                                                                      "enableAddRep",
                                                                      $$a
                                                                        .slice(
                                                                          0,
                                                                          $$i
                                                                        )
                                                                        .concat(
                                                                          $$a.slice(
                                                                            $$i +
                                                                              1
                                                                          )
                                                                        )
                                                                    )
                                                                }
                                                              } else {
                                                                _vm.$set(
                                                                  heading,
                                                                  "enableAddRep",
                                                                  $$c
                                                                )
                                                              }
                                                            }
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("label", {
                                                          staticClass:
                                                            "custom-control-label",
                                                          staticStyle: {
                                                            "margin-left":
                                                              "30px",
                                                            "margin-top": "2px"
                                                          },
                                                          attrs: {
                                                            for: heading.sortid
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("label", [
                                                          _vm._v(
                                                            "\n                              Add Rep at Sub-Section Level\n                          "
                                                          )
                                                        ])
                                                      ]
                                                    ),
                                                _vm._v(" "),
                                                heading.tasks.length > 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "float-left font-15  text-center override-padding",
                                                        staticStyle: {
                                                          width: "10.67%"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          Rep Goal\n                        "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                heading.tasks.length > 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "float-left font-15 text-center override-padding",
                                                        staticStyle: {
                                                          width: "14.33%"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          Rep Competency\n                        "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "float-right font-15  text-align-right override-padding",
                                                    staticStyle: {
                                                      width: "16.33%"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn save-button-width btn-red btn-md input-height-15",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.choose_tasks_redirect(
                                                              subTaskIndex,
                                                              headingIndex
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-plus",
                                                          attrs: {
                                                            "aria-hidden":
                                                              "true"
                                                          }
                                                        }),
                                                        _vm._v(" Task")
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.sub_tasklist_obj
                                                      .tasklist.status ==
                                                    "DRAFT"
                                                      ? _c("i", {
                                                          staticClass:
                                                            "cursor-pointer fa fa-times",
                                                          staticStyle: {
                                                            "padding-left":
                                                              "10px"
                                                          },
                                                          attrs: {
                                                            "aria-hidden":
                                                              "true"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.deleteHeadingConfirm(
                                                                subTaskIndex,
                                                                headingIndex
                                                              )
                                                            }
                                                          }
                                                        })
                                                      : _vm._e()
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticStyle: { clear: "both" }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "task_container",
                                                class: [
                                                  heading.tasks.length > 0
                                                    ? "margin-bottom-5 task_container_padding"
                                                    : "",
                                                  ,
                                                  parseInt(headingIndex) +
                                                    parseInt(1) ===
                                                  sub_tasklist.headings.length
                                                    ? "margin-bottom-0"
                                                    : ""
                                                ]
                                              },
                                              [
                                                _c("div", {
                                                  staticStyle: { clear: "both" }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "task_list" },
                                                  [
                                                    _c(
                                                      "ul",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "sortable",
                                                            rawName:
                                                              "v-sortable",
                                                            value: {
                                                              onEnd:
                                                                _vm.reorderSubtaskTask,
                                                              handle:
                                                                ".handle3",
                                                              group: {
                                                                name:
                                                                  "heading-" +
                                                                  subTaskIndex +
                                                                  "-" +
                                                                  headingIndex,
                                                                put: _vm.createTaskGroupArray()
                                                              }
                                                            },
                                                            expression:
                                                              "{onEnd: reorderSubtaskTask, handle: '.handle3', group: { name: 'heading-' + subTaskIndex + '-' + headingIndex, put: createTaskGroupArray() } }"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "counter_task-list tasks_list list-group col-lg-12",
                                                        staticStyle: {
                                                          "padding-right": "0"
                                                        },
                                                        attrs: {
                                                          "data-id":
                                                            subTaskIndex +
                                                            "-" +
                                                            headingIndex
                                                        }
                                                      },
                                                      _vm._l(
                                                        heading.tasks,
                                                        function(
                                                          task,
                                                          taskIndex
                                                        ) {
                                                          return _c(
                                                            "li",
                                                            {
                                                              key: task.sortid,
                                                              staticClass:
                                                                "list-group-item input-height-25"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "task_item"
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "handle3 float-left  override-padding",
                                                                      staticStyle: {
                                                                        width:
                                                                          "54.33%"
                                                                      }
                                                                    },
                                                                    [
                                                                      _c("i", {
                                                                        staticClass:
                                                                          "fa fa-arrows padding-right-5",
                                                                        attrs: {
                                                                          "aria-hidden":
                                                                            "true"
                                                                        }
                                                                      }),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "counter_task-list__counter"
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        "\n                                  " +
                                                                          _vm._s(
                                                                            task.name
                                                                          ) +
                                                                          "\n                                 "
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "float-left override-padding",
                                                                      staticStyle: {
                                                                        width:
                                                                          "10.67%"
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "input",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "model",
                                                                              rawName:
                                                                                "v-model",
                                                                              value:
                                                                                task.defaultRepCount,
                                                                              expression:
                                                                                "task.defaultRepCount"
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "  default-hours-height",
                                                                          staticStyle: {
                                                                            width:
                                                                              "69%",
                                                                            "margin-left":
                                                                              "15px"
                                                                          },
                                                                          attrs: {
                                                                            id:
                                                                              "rep_count_" +
                                                                              subTaskIndex +
                                                                              "-" +
                                                                              headingIndex +
                                                                              "-" +
                                                                              taskIndex,
                                                                            maxlength:
                                                                              "5",
                                                                            placeholder:
                                                                              "0"
                                                                          },
                                                                          domProps: {
                                                                            value:
                                                                              task.defaultRepCount
                                                                          },
                                                                          on: {
                                                                            blur: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.onBlurDefaultGoalEvent(
                                                                                subTaskIndex,
                                                                                headingIndex,
                                                                                taskIndex
                                                                              )
                                                                            },
                                                                            input: function(
                                                                              $event
                                                                            ) {
                                                                              if (
                                                                                $event
                                                                                  .target
                                                                                  .composing
                                                                              ) {
                                                                                return
                                                                              }
                                                                              _vm.$set(
                                                                                task,
                                                                                "defaultRepCount",
                                                                                $event
                                                                                  .target
                                                                                  .value
                                                                              )
                                                                            }
                                                                          }
                                                                        }
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "float-left override-padding",
                                                                      staticStyle: {
                                                                        width:
                                                                          "14.33%"
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "input",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "model",
                                                                              rawName:
                                                                                "v-model",
                                                                              value:
                                                                                task.defaultRepCompetency,
                                                                              expression:
                                                                                "task.defaultRepCompetency"
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "default-hours-height",
                                                                          staticStyle: {
                                                                            width:
                                                                              "64%",
                                                                            "margin-left":
                                                                              "15px"
                                                                          },
                                                                          attrs: {
                                                                            id:
                                                                              "rep_competency_" +
                                                                              subTaskIndex +
                                                                              "-" +
                                                                              headingIndex +
                                                                              "-" +
                                                                              taskIndex,
                                                                            maxlength:
                                                                              "5",
                                                                            placeholder:
                                                                              "0"
                                                                          },
                                                                          domProps: {
                                                                            value:
                                                                              task.defaultRepCompetency
                                                                          },
                                                                          on: {
                                                                            blur: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.onBlurDefaultGoalEvent(
                                                                                subTaskIndex,
                                                                                headingIndex,
                                                                                taskIndex
                                                                              )
                                                                            },
                                                                            input: function(
                                                                              $event
                                                                            ) {
                                                                              if (
                                                                                $event
                                                                                  .target
                                                                                  .composing
                                                                              ) {
                                                                                return
                                                                              }
                                                                              _vm.$set(
                                                                                task,
                                                                                "defaultRepCompetency",
                                                                                $event
                                                                                  .target
                                                                                  .value
                                                                              )
                                                                            }
                                                                          }
                                                                        }
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "float-left override-padding text-center",
                                                                      staticStyle: {
                                                                        width:
                                                                          "8.33%"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                   \n                                 "
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "float-left font-15  override-padding text-align-right",
                                                                      staticStyle: {
                                                                        width:
                                                                          "12.33%"
                                                                      }
                                                                    },
                                                                    [
                                                                      task.priority >
                                                                      0
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticStyle: {
                                                                                "padding-right":
                                                                                  "40px"
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                    P" +
                                                                                  _vm._s(
                                                                                    task.priority
                                                                                  ) +
                                                                                  "\n                                 "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                " "
                                                                              )
                                                                            ]
                                                                          ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c("i", {
                                                                        staticClass:
                                                                          "cursor-pointer fa fa-times",
                                                                        attrs: {
                                                                          "aria-hidden":
                                                                            "true"
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.deleteTaskConfirm(
                                                                              subTaskIndex,
                                                                              headingIndex,
                                                                              taskIndex
                                                                            )
                                                                          }
                                                                        }
                                                                      })
                                                                    ]
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("div", {
                                                                staticStyle: {
                                                                  clear: "both"
                                                                }
                                                              })
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  ])
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          sub_tasklist.headings.length === 0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "subtask_task_container subtask_task_container_padding",
                                  class: [
                                    sub_tasklist.tasks.length > 0
                                      ? "margin-bottom-5 "
                                      : "",
                                    sub_tasklist.tasks.length === 0
                                      ? "backgroud-none subtask_task_container_padding2"
                                      : ""
                                  ],
                                  staticStyle: { "padding-right": "0" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "subtask_task_list" },
                                    [
                                      _c(
                                        "ul",
                                        {
                                          directives: [
                                            {
                                              name: "sortable",
                                              rawName: "v-sortable",
                                              value: {
                                                onEnd: _vm.reorderSubtaskTask,
                                                handle: ".handle4",
                                                group: {
                                                  name: "task-" + subTaskIndex,
                                                  put: _vm.createTaskGroupArray()
                                                }
                                              },
                                              expression:
                                                "{onEnd: reorderSubtaskTask, handle: '.handle4', group: { name: 'task-' + subTaskIndex, put: createTaskGroupArray() }}"
                                            }
                                          ],
                                          staticClass:
                                            "counter_task-list col-lg-12",
                                          attrs: {
                                            "data-id": subTaskIndex + "-null"
                                          }
                                        },
                                        _vm._l(sub_tasklist.tasks, function(
                                          task,
                                          taskIndex
                                        ) {
                                          return _c(
                                            "li",
                                            {
                                              key: task.sortid,
                                              staticClass:
                                                "list-group-item input-height-25"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "task_item" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "handle4 float-left  override-padding",
                                                      staticStyle: {
                                                        width: "53.33%"
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-arrows padding-right-5",
                                                        attrs: {
                                                          "aria-hidden": "true"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass:
                                                          "counter_task-list__counter"
                                                      }),
                                                      _vm._v(
                                                        "\n                          " +
                                                          _vm._s(task.name) +
                                                          "\n                         "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "float-left override-padding text-center",
                                                      staticStyle: {
                                                        width: "10.67%"
                                                      }
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              task.defaultRepCount,
                                                            expression:
                                                              "task.defaultRepCount"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "  default-hours-height",
                                                        staticStyle: {
                                                          width: "69%",
                                                          "margin-left": "15px"
                                                        },
                                                        attrs: {
                                                          id:
                                                            "rep_count_" +
                                                            subTaskIndex +
                                                            "-" +
                                                            taskIndex,
                                                          maxlength: "5",
                                                          placeholder: "0"
                                                        },
                                                        domProps: {
                                                          value:
                                                            task.defaultRepCount
                                                        },
                                                        on: {
                                                          blur: function(
                                                            $event
                                                          ) {
                                                            return _vm.onBlurDefaultGoalEvent(
                                                              subTaskIndex,
                                                              "null",
                                                              taskIndex
                                                            )
                                                          },
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.$set(
                                                              task,
                                                              "defaultRepCount",
                                                              $event.target
                                                                .value
                                                            )
                                                          }
                                                        }
                                                      })
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "float-left override-padding text-center",
                                                      staticStyle: {
                                                        width: "14.33%"
                                                      }
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              task.defaultRepCompetency,
                                                            expression:
                                                              "task.defaultRepCompetency"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "default-hours-height",
                                                        staticStyle: {
                                                          width: "64%",
                                                          "margin-left": "15px"
                                                        },
                                                        attrs: {
                                                          id:
                                                            "rep_competency_" +
                                                            subTaskIndex +
                                                            "-" +
                                                            taskIndex,
                                                          maxlength: "5",
                                                          placeholder: "0"
                                                        },
                                                        domProps: {
                                                          value:
                                                            task.defaultRepCompetency
                                                        },
                                                        on: {
                                                          blur: function(
                                                            $event
                                                          ) {
                                                            return _vm.onBlurDefaultGoalEvent(
                                                              subTaskIndex,
                                                              "null",
                                                              taskIndex
                                                            )
                                                          },
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.$set(
                                                              task,
                                                              "defaultRepCompetency",
                                                              $event.target
                                                                .value
                                                            )
                                                          }
                                                        }
                                                      })
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "float-left  override-padding text-center",
                                                      staticStyle: {
                                                        width: "8.33%"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                           \n                         "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "float-left font-15 override-padding text-align-right",
                                                      staticStyle: {
                                                        width: "13.33%"
                                                      }
                                                    },
                                                    [
                                                      task.priority > 0
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                "padding-right":
                                                                  "40px"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                              P" +
                                                                  _vm._s(
                                                                    task.priority
                                                                  ) +
                                                                  "\n                           "
                                                              )
                                                            ]
                                                          )
                                                        : _c("span", [
                                                            _vm._v(" ")
                                                          ]),
                                                      _vm._v(" "),
                                                      _c("i", {
                                                        staticClass:
                                                          "cursor-pointer fa fa-times",
                                                        attrs: {
                                                          "aria-hidden": "true"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.deleteTaskConfirm(
                                                              subTaskIndex,
                                                              "null",
                                                              taskIndex
                                                            )
                                                          }
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticStyle: { clear: "both" }
                                              })
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    }),
                    0
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "margin-bottom-20",
                  staticStyle: { clear: "both" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "task-list-summary float-left col-10 override-padding"
                  },
                  [
                    _c("span", [_vm._v("Tasks List Summary:")]),
                    _vm._v(" "),
                    _c("span", { staticStyle: { "padding-left": "25px" } }, [
                      _vm._v(_vm._s(_vm.subtaskCount) + " Sections")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticStyle: { "padding-left": "25px" } }, [
                      _vm._v(_vm._s(_vm.headingsCount) + " Sub Sections")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticStyle: { "padding-left": "25px" } }, [
                      _vm._v(_vm._s(_vm.tasksCount) + " Tasks")
                    ])
                  ]
                ),
                _vm._v(" "),
                this.sub_tasklist_obj.sub_tasklists_lists.length > 0
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "submit float-right col-2 override-padding",
                        on: { click: _vm.onSubmit }
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "col-12 btn btn-red btn-md col-12 input-height-15",
                            attrs: { type: "submit" }
                          },
                          [_vm._v("Save List")]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticStyle: { clear: "both" } }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "margin-bottom-10",
                  staticStyle: { clear: "both" }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "page_angle_down page_to_down" }, [
                  _c("div", { staticClass: "scroll_box cursor-pointer" }, [
                    _c(
                      "span",
                      {
                        staticClass: "scroll_up_down",
                        on: {
                          click: function($event) {
                            return _vm.scrollToElement("up")
                          }
                        }
                      },
                      [_c("i", { staticClass: "fa fa-angle-up angle_font" })]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "EditTasklistModal",
                {
                  attrs: { isModalVisible: _vm.isEditModalVisible },
                  on: {
                    close: function($event) {
                      _vm.isEditModalVisible = false
                    }
                  }
                },
                [
                  _vm.loading
                    ? _c("span", { staticClass: "pull-right text-danger" }, [
                        _vm._v("\n          Loading...\n        ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "sub-heading",
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [_c("h3", [_vm._v("Update Tasklist")])]
                  ),
                  _vm._v(" "),
                  _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                    _c("div", { staticClass: "col-11 override-padding" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.edit_tasklist_title,
                            expression: "edit_tasklist_title"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "col-lg-11 input-height-25",
                        attrs: {
                          name: "edit_tasklist_title",
                          placeholder: "Enter Tasklist Title",
                          maxlength: "255"
                        },
                        domProps: { value: _vm.edit_tasklist_title },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.edit_tasklist_title = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.verrors.firstByRule("edit_tasklist_title", "required")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "margin-bottom-5 validate-warning-msg"
                            },
                            [_vm._v("Tasklist title is required")]
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "margin-bottom-10",
                      staticStyle: { clear: "both" }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-11 override-padding",
                        staticStyle: { display: "flex" }
                      },
                      [
                        _vm.masterAdmin === true &&
                        !_vm.$store.state.switch_admin_username &&
                        this.sub_tasklist_obj.tasklist.public == "1"
                          ? _c(
                              "div",
                              {
                                staticClass: "search-padd",
                                staticStyle: { height: "30px", width: "74%" },
                                attrs: { id: "affliate-wrapper" }
                              },
                              [
                                _c("multiselect", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  attrs: {
                                    options: _vm.affiliate_options,
                                    "track-by": "value",
                                    label: "text",
                                    placeholder: "Select Affiliate",
                                    multiple: true,
                                    "close-on-select": false,
                                    "show-labels": false,
                                    name: "edit_affiliate[]",
                                    id: "edit_affiliate"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "selection",
                                      fn: function(ref) {
                                        var values = ref.values
                                        var search = ref.search
                                        var isOpen = ref.isOpen
                                        return [
                                          values.length && !isOpen
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "multiselect__single"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(values.length) +
                                                      " selected"
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ]),
                                  model: {
                                    value: _vm.edit_affiliate,
                                    callback: function($$v) {
                                      _vm.edit_affiliate = $$v
                                    },
                                    expression: "edit_affiliate"
                                  }
                                }),
                                _vm._v(" "),
                                _vm.verrors.firstByRule(
                                  "edit_affiliate[]",
                                  "required"
                                )
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "margin-bottom-5 validate-warning-msg"
                                      },
                                      [_vm._v("Affiliate is required")]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-red col-lg-2 col-sm-2 col-3 input-height-25 createBtn",
                            on: {
                              click: function($event) {
                                return _vm.editTaskListAction()
                              }
                            }
                          },
                          [_c("b", [_vm._v("Update")])]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.verrors.firstByRule("edit_affiliate", "required")
                      ? _c(
                          "div",
                          {
                            staticClass: "margin-bottom-5 validate-warning-msg"
                          },
                          [_vm._v("Affiliate is required")]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "col-3 override-padding",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "DeleteModal",
                {
                  attrs: {
                    isModalVisible: _vm.isModalVisible,
                    id: _vm.id,
                    parent_id: _vm.parent_id
                  },
                  on: {
                    close: function($event) {
                      _vm.isModalVisible = false
                    }
                  }
                },
                [
                  _vm.loading
                    ? _c("span", { staticClass: "pull-right text-danger" }, [
                        _vm._v("\n          Loading...\n        ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "sub-heading",
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [_vm._v(_vm._s(_vm.deleteMessage))]
                  ),
                  _vm._v(" "),
                  _c("div", { attrs: { slot: "body" }, slot: "body" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "col-3 override-padding",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "left col-12 btn btn-red",
                          on: {
                            click: function($event) {
                              _vm.isModalVisible = false
                              _vm.deleteAction()
                            }
                          }
                        },
                        [_vm._v("Confirm")]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "ValidationModal",
                {
                  attrs: { isModalVisible: _vm.isValidationModalVisible },
                  on: {
                    close: function($event) {
                      _vm.isValidationModalVisible = false
                    }
                  }
                },
                [
                  _vm.loading
                    ? _c("span", { staticClass: "pull-right text-danger" }, [
                        _vm._v("\n          Loading...\n        ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "sub-heading",
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [_vm._v(_vm._s(_vm.validationMessage))]
                  ),
                  _vm._v(" "),
                  _c("div", { attrs: { slot: "body" }, slot: "body" }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "col-3 override-padding",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  })
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31a1a9be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31a1a9be","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/create_sub_tasklists.vue
// module id = null
// module chunks = 